module.exports = __webpack_public_path__ + "magicbeans.jpg?9ec9f0d932ccc780bf72dc9a0ea26f98";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/magicbeans.jpg
// module id = 133
// module chunks = 0